import {action, observable} from 'mobx';
import questionInfo from "../data/questionInfo";

class MainStore {
    @observable isTest = false;
    @observable questionList = questionInfo.questions;

    resultSet = {
        future: 0,
        conflict: 0,
        problem: 0,
        avoid: 0,
    };

    @action setIsTest(flag) {
        this.isTest = flag;
    }

    @action setQuestionValue(list, index, value) {
        list[index].value = value;
    }
}

export default new MainStore();
